module.exports = "<li ng-transclude></li> ";